import { RootState } from "../../store";

export const getRecentSiteSearches = (state: RootState) =>
  state.homePage.recentSearches;
